import request from 'utils/request';

export function fetchUser(options) {
  const requestOptions = {
    ...options,
    method: 'GET',
  };

  return request('/api/v3/user', requestOptions);
}

export function addLogo(params, options = {}, body = {}) {
  const requestOptions = {
    ...options,
    body,
    method: 'POST',
  };

  return request('/api/v3/user/company-logo-url', requestOptions);
}

export function deleteLogo(params, options = {}) {
  const requestOptions = {
    ...options,
    method: 'DELETE',
  };

  return request('/api/v3/user/company-logo-url', requestOptions);
}

// more methods to be added...
